export enum OccasionsEnum {
  'DINE_IN' = 'DINE_IN',
  'DRIVE_THRU' = 'DRIVE_THRU',
  'CARRYOUT' = 'CARRYOUT',
  'DELIVERY' = 'DELIVERY',
}

interface ChoiceDetails {
  choiceId: string;
  choiceCode: string;
  name: string;
  internalName: string;
}

interface ProductDetails {
  productId: string;
  productCode: string;
  name: string;
  internalName: string;
  description: string;
}

interface OptionValue {
  internalName: string;
  name: string;
}

interface SelectedOptions {
  optionValue: OptionValue;
}

interface VariantDetails {
  variantId: string;
  variantCode: string;
  name: string;
  product: ProductDetails;
  selectedOptions: SelectedOptions[];
}

interface BundleChoices {
  choice: ChoiceDetails;
  defaultVariants: VariantDetails[];
}

export interface BundleChoiceDetail {
  choiceId: string;
  choiceName: string;
  productName: string;
  variantName: string;
  addOnFlag: boolean;
}

export interface Patches {
  description: string;
  type: string;
  price: string;
}

interface UpchargePatch {
  isLock: boolean;
  description: string;
  type: string;
  patchOptions: PatchOption[];
}

interface PatchOption {
  patchId: string;
  price: number;
}

export interface BundleDetails {
  id: string;
  code: string;
  name: string;
  internalName: string;
  occasions: OccasionsEnum[];
  choices: BundleChoices[];
  availablePrices: number[];
  recommendedPrices: number[];
  hagPrices: number[];
  isLocked: boolean;
  isVisible: boolean;
  isVisibleOnline: boolean;
  isRedeemableOnline: boolean;
  previousVisibility: boolean | null;
  fzGroupCount: number | null;
  chosenPrice: number;
  defaultPrice: number;
  isNationalProgramLiveOrOptIn: boolean;
  bundleLinkedToDto?: LinkedBundles[];
  linkedBundleName?: string;
  isLockRedeemableOnline: boolean;
  lockRedeemableOnline: boolean;
  isLockVisibleOnline: boolean;
  lockVisibleOnline: boolean;
  isLockPrice: boolean;
  upChargePrice?: number;
  isUpchargeRequired: boolean;
  nationalProgramRedeemableOnline?: boolean;
  nationalProgramVisibleOnline?: boolean;
  bundleStatus?: boolean;
  activeStoreGroupCount?: number;
  choiceDetails?: BundleChoiceDetail[];
}

export interface BundleUpchargeData {
  storeGroups: BundleUpchargeStoreGroup[];
  upchargePatches: UpchargePatch[];
}

export interface BundleUpchargeStoreGroup {
  storeGroupId: string;
  storeGroupName: string;
  patches: Patches[];
}

export interface BundleUpchargeStoreData {
  stores: BundleUpchargeStore[];
  upchargePatches: UpchargePatch[];
}

export interface BundleUpchargeStore {
  storeNo: string;
  patches: StorePatches[];
}

export interface StorePatches {
  description: string;
  price: string;
  isLocked: boolean;
}

export interface MissingVariant {
  productName: string;
  productDescription: string;
  stores: string;
}

export interface BundleMissingVariantsResponse {
  storeGroupName: string;
  missingVariants: MissingVariant[];
}

export interface StoreGroup {
  groupId: string;
  chosenPrice: number;
  previousPrice: number | null;
  groupName: string;
  createdAt: string;
  updatedAt: string;
  status: string;
  isExcluded: boolean;
  chosenRedeemableOnline: boolean;
  chosenVisibleOnline: boolean;
  previousRedeemableOnline: boolean;
  previousVisibleOnline: boolean;
  pendingPriceChange?: boolean;
  isVariantMissing?: boolean;
}

export interface EditBundlePriceRequestBody {
  groups: string[];
  price: string;
  redeemableOnline?: boolean;
  visibleOnline?: boolean;
  /** Live NP future SGA edit: persist chosen_* only and skip Byte updates. */
  updateChosenSettingsOnly?: boolean;
}

export interface DeactivateBundleRequestBody {
  allGroups: boolean;
  groups: string[];
  /** Live NP future SGA edit: clear chosen_* only and skip Byte updates and email. */
  updateChosenSettingsOnly?: boolean;
}

export interface EditLinkedBundlePriceRequestBody {
  groups?: StoreGroup[];
  redeemableOnline?: boolean;
  visibleOnline?: boolean;
}

export interface BundleAvailablePriceRequestBody {
  price: number;
}

export interface BundleStatistics {
  recommendedPrices: number[];
  availablePrices: number[];
  legacyPrices: number[];
  recommendedPriceStoreCount: number;
  nonRecommendedPriceStoreCount: number;
  bundleUniquePricesCount: number;
}

export interface BundleStatisticsTable {
  price: any;
  storeCount: any;
  type: any;
}
export interface LinkedBundles {
  id: string;
  code: string;
  name: string;
  internalName: string;
  chosenPrice: string;
  upChargePrice: number;
}
export interface CreateLinkedBundles {
  linkedBundle: LinkedBundle[];
  linkedBundleName: string | null;
  recommendedPrices: string[];
}

export interface LinkedBundle {
  bundleUUID?: string;
  upChargePrice: number | null;
}

export interface NavigationCode {
  id?: string;
  navCode: string[];
}

export type StoreCount = {
  storeNo: string;
  org: string;
};

export type BundleStoreCount = {
  bundleCode: string;
  pricePoint: number;
  totalStores: number;
  stores: StoreCount[];
};
